import { snackbar } from "@/core/controller/snackbar_controller";
import { headersExcel } from "../const/headersExcel";
import { headers } from "../const/headers";
import { equipmentHistoryDefault } from "../domain/equipmentHistory/equipmentHistory"
import { hadColumnsAccess } from '@/core/domain/model/permission';
import { generateExcelFile } from '@/helpers/excelExportHelper';

class EquipmentHistoryController {
    context = null;
    headers = headers;
    loading = false;
    permissionID = 9;
    search = "";
    searchClient = "";
    searchEquipment = "";
    searchVehicle = "";
    searchAccount = "";
    dialog = false;
    dialogUpdate = false;
    form = equipmentHistoryDefault();
    loadingBtnExcel = false;

    selectedItems = []
    equipmentHistoryPagination = {
      total: 0,
      items: []
    }

    options = {
      page: 1,
      itemsPerPage: 40,
      groupBy: [],
      sortBy: ["createdDate"],
      groupDesc: [],
      multiSort: false,
      mustSort: false,
      sortDesc: [true]
    }

    clientPagination = {
      total: 0,
      items: []
    }
    clientOptions = {
      page: 1,
      itemsPerPage: 40,
      groupBy: [],
      sortBy: ["name"],
      groupDesc: [],
      multiSort: false,
      mustSort: false,
      sortDesc: []
    }

    equipmentPagination = {
      total: 0,
      items: []
    }  
    equipmentOptions = {
      page: 1,
      itemsPerPage: 40,
      groupBy: [],
      sortBy: ["name"],
      groupDesc: [],
      multiSort: false,
      mustSort: false,
      sortDesc: []
    }

    vehiclePagination = {
      total: 0,
      items: []
    }
    vehicleOptions = {
      page: 1,
      itemsPerPage: 40,
      groupBy: [],
      sortBy: ["plate"],
      groupDesc: [],
      multiSort: false,
      mustSort: false,
      sortDesc: []
    }

    accountPagination = {
      total: 0,
      items: []
    }
    accountOptions = {
      page: 1,
      itemsPerPage: 40,
      groupBy: [],
      sortBy: ["name"],
      groupDesc: [],
      multiSort: false,
      mustSort: false,
      sortDesc: []
    }


  constructor(
    context,
    fetchEquipmentHistoryUseCaseImpl,
    createEquipmentHistoryUseCaseImpl,
    changeEquipmentHistoryUseCaseImpl,
    getEquipmentHistoryUseCaseImpl,
    fetchClientUseCaseImpl,
    fetchEquipmentUseCaseImpl,
    fetchVehicleUseCaseImpl,
    fetchTechnicianUseCaseImpl
  ) {
    this.context = context
    this.fetchEquipmentHistoryUseCaseImpl = fetchEquipmentHistoryUseCaseImpl
    this.createEquipmentHistoryUseCaseImpl = createEquipmentHistoryUseCaseImpl
    this.changeEquipmentHistoryUseCaseImpl = changeEquipmentHistoryUseCaseImpl
    this.getEquipmentHistoryUseCaseImpl = getEquipmentHistoryUseCaseImpl
    this.fetchClientUseCaseImpl = fetchClientUseCaseImpl
    this.fetchEquipmentUseCaseImpl = fetchEquipmentUseCaseImpl
    this.fetchVehicleUseCaseImpl = fetchVehicleUseCaseImpl
    this.fetchTechnicianUseCaseImpl = fetchTechnicianUseCaseImpl
  }

  getColumnsAccess() {
    return this.headers.filter(header => hadColumnsAccess(header.value, this.permissionID))
  }

  async paginate() {
    this.loading = true
    try {
      this.equipmentHistoryPagination = await this.fetchEquipmentHistoryUseCaseImpl(this.options, this.search, this.form);
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false
    }
  }

  async clientPaginate() {
    try {
      this.clientPagination = await this.fetchClientUseCaseImpl(this.clientOptions, this.searchClient)
    } catch (error) {
      console.log(error);
    }
  }

  async vehiclePaginate() {
    try {
      this.vehiclePagination = await this.fetchVehicleUseCaseImpl(this.vehicleOptions, this.searchVehicle)
    } catch (error) {
      console.log(error);
    }
  }

  async equipmentPaginate() {
    try {
      this.equipmentPagination = await this.fetchEquipmentUseCaseImpl(this.equipmentOptions, this.searchEquipment)
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false
    }
  }

  async technicianPaginate() {
    try {
      this.technicianPagination = await this.fetchTechnicianUseCaseImpl(this.technicianOptions, this.searchTechnician)
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false
    }
  }

  // open() {
  //   this.form = equipmentHistoryDefault();
  // }
  
  //filtro de pesquisa
  // async filter() {
  //   try {
  //     this.equipmentHistoryPagination = await this.fetchEquipmentHistoryUseCaseImpl(this.options, this.search, this.form)
      
  //     this.dialog = false;
      
  //   } catch (error) {
  //     console.log(error);
  //   }
  // }

  async change(item) {
    this.dialogUpdate = true
    this.form = { ...item }
  }

  async create(){
    if (this.context.$refs.crud.validate()) {
      try {
        this.loading = true
        if (this.form.id != 0) {
          await this.changeEquipmentHistoryUseCaseImpl(this.form.id, this.form)
          snackbar.show({ message: "Alterado com sucesso!!!", color: "#008000", timeout: 3000 })
        } 
      } catch (error) {
        snackbar.show({ message: error.toString(), color: "#ff0000", timeout: 3000 })
      } finally {
        this.paginate()
        this.loading = false
        this.dialogUpdate = false
      }
    }
  }

  async exportExcel () {
     try {
      this.loadingBtnExcel = true;
      const paginate = { ...this.options };
      paginate.itemsPerPage = 30000;
      
      const response = await this.fetchEquipmentHistoryUseCaseImpl(paginate, "");
      
      await generateExcelFile(
        response.items,
        headersExcel,
        this.permissionID,
        'historico-equipamentos',
        'equipmentHistory'
      );
      
    } catch (error) {
      snackbar.show({ message: error.toString() });
    } finally {
      this.loadingBtnExcel = false;
    }
  }
  watchOptions() {
    this.paginate();
  }
  watchSearch() {
    this.paginate();
  }
  watchClientOptions() {
    this.clientPaginate();
  }
  watchClientSearch() {
    this.clientPaginate();
  }
  watchEquipmentOptions() {
    this.equipmentPaginate();
  }
  watchEquipmentSearch() {
    this.equipmentPaginate();
  }
  watchVehicleOptions() {
    this.vehiclePaginate();
  }
  watchVehicleSearch() {
    this.vehiclePaginate();
  }
  watchTechnicianOptions() {
    this.technicianPaginate();
  }
  watchTechnicianSearch() {
    this.technicianPaginate();
  }
}

export default EquipmentHistoryController